import { z } from 'zod';

export const outreachSafetyMatchSchema = z.object({
  id: z.string().uuid(),
  lead_id: z.string().uuid(),
  matched_entity_type: z.enum([
    'customer_location',
    'open_deal',
    'blueprint_lead',
    'existing_lead',
    'outreach_suppression',
    'mailmeteor_suppression',
    'resend_suppression',
    'operator_account',
    'non_icp',
    'unknown',
  ]),
  matched_entity_id: z.string().uuid().nullable(),
  matched_entity_label: z.string().nullable(),
  match_method: z.enum([
    'license_exact',
    'dedupe_key_exact',
    'email_exact',
    'contact_email_exact',
    'domain_exact',
    'normalized_name_address_state',
    'normalized_name_city_state',
    'operator_domain_brand',
    'fuzzy_name_geo',
    'manual',
  ]).nullable(),
  confidence: z.enum(['exact', 'strong', 'moderate', 'fuzzy']).nullable(),
  safety_disposition: z.enum(['needs_review', 'account_expansion_review', 'blocked', 'released']),
  suppression_reason: z.enum([
    'do_not_contact',
    'unsubscribe',
    'hard_bounce',
    'spam_complaint',
    'invalid_email',
    'current_customer',
    'existing_customer',
    'open_deal',
    'inbound_dup',
    'manual_block',
    'other',
  ]).nullable(),
  disqualification_reason: z.enum([
    'cbd_only',
    'closed',
    'delivery_only_no_instore_case',
    'inactive_license',
    'revoked_license',
    'not_cannabis_storefront',
    'other',
  ]).nullable(),
  source: z.string().nullable(),
  evaluated_at: z.string().datetime({ offset: true }).nullable(),
  created_at: z.string().datetime({ offset: true }),
  reviewed_at: z.string().datetime({ offset: true }).nullable(),
  released_at: z.string().datetime({ offset: true }).nullable(),
}).strict();

export const outreachSafetyMatchesSuccessSchema = z.object({
  ok: z.literal(true),
  matches: z.array(outreachSafetyMatchSchema).max(200),
}).strict();
